/* eslint-disable no-param-reassign, consistent-return */
import produce from "immer";
import actionTypes from "../Actions/types";

export const initialState = {
    wallets: [],
    selectedWallet: {},
    walletBalances: {},
};

const normalizeWalletEntry = (item = {}) => {
    const chain =
        String(item.chain || "solana")
            .trim()
            .toLowerCase() === "ethereum"
            ? "ethereum"
            : "solana";
    const address = String(item.address || "").trim();
    const uid =
        item.uid || item.id || `${chain}_${address.slice(0, 8)}_${Date.now()}`;
    return {
        uid,
        name: String(
            item.name || `${chain === "solana" ? "Solana" : "Ethereum"} wallet`
        ).trim(),
        chain,
        address,
        addedOn: item.addedOn || Date.now(),
    };
};

const reducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {
            case "persist/REHYDRATE": {
                const incoming = action.payload?.wallets;
                if (incoming && typeof incoming === "object") {
                    if (Array.isArray(incoming.wallets)) {
                        draft.wallets =
                            incoming.wallets.map(normalizeWalletEntry);
                    }
                    if (
                        incoming.walletBalances &&
                        typeof incoming.walletBalances === "object"
                    ) {
                        draft.walletBalances = incoming.walletBalances;
                    }
                }
                break;
            }
            case actionTypes.UPDATE_BACKEDUP_WALLETS: {
                const list = Array.isArray(action.payload)
                    ? action.payload
                    : [];
                draft.wallets = list.map(normalizeWalletEntry);
                break;
            }
            case actionTypes.ADD_WALLET: {
                const normalized = normalizeWalletEntry(action.payload);
                const existsIdx = draft.wallets.findIndex(
                    (w) =>
                        w.chain === normalized.chain &&
                        w.address.toLowerCase() ===
                            normalized.address.toLowerCase()
                );
                if (existsIdx >= 0) {
                    draft.wallets[existsIdx] = {
                        ...draft.wallets[existsIdx],
                        name: normalized.name,
                    };
                } else {
                    draft.wallets.unshift(normalized);
                }
                break;
            }
            case actionTypes.UPDATE_WALLET: {
                const { uid, name } = action.payload || {};
                draft.wallets = draft.wallets.map((w) =>
                    w.uid === uid
                        ? { ...w, name: String(name || w.name).trim() }
                        : w
                );
                if (draft.selectedWallet?.uid === uid && name) {
                    draft.selectedWallet = {
                        ...draft.selectedWallet,
                        name: String(name).trim(),
                    };
                }
                break;
            }
            case actionTypes.DELETE_WALLET: {
                const { uid } = action.payload || {};
                const target = draft.wallets.find((w) => w.uid === uid);
                draft.wallets = draft.wallets.filter((w) => w.uid !== uid);
                if (target) {
                    const cacheKey = `${
                        target.chain
                    }:${target.address.toLowerCase()}`;
                    delete draft.walletBalances[cacheKey];
                }
                if (draft.selectedWallet?.uid === uid) {
                    draft.selectedWallet = {};
                }
                break;
            }
            case actionTypes.SET_SELECTED_WALLET: {
                draft.selectedWallet = action.payload || {};
                break;
            }
            case actionTypes.SET_WALLET_BALANCE_CACHE: {
                const { chain, address, data } = action.payload || {};
                if (chain && address && data) {
                    const key = `${String(chain).toLowerCase()}:${String(
                        address
                    )
                        .trim()
                        .toLowerCase()}`;
                    draft.walletBalances[key] = data;
                }
                break;
            }
            default:
                return draft;
        }
    });

export default reducer;
